export const depresion2_catalog = [
    {
        "n": 1,
        "pregunta": ". Humor deprimido (tristeza, depresión, desamparo, inutilidad)",
        "respuestas": [
            "0. Ausente",
            "1. Estas sensaciones se indican solamente al ser preguntado",
            "2. Estas sensaciones se relatan oral y espontáneamente",
            "3. Sensaciones no comunicadas verbalmente, es decir, por la expresión facial,la postura, la voz y la tendencia al llanto.",
            "4. El paciente manifiesta estas sensaciones en su comunicación verbal y no verbal de forma espontánea",
        ]
    },
    {
        "n": 2,
        "pregunta": "2. Sensación de culpabilidad",
        "respuestas": [
            "0. Ausente",
            "1. Se culpa a sí mismo, cree haber decepcionado a la gente",
            "2. Ideas de culpabilidad, o meditación sobre errores pasados o malas acciones",
            "3. La enfermedad actual es un castigo. Ideas delirantes de culpabilidad",
            "4. Oye voces acusatorias o de denuncia y/o experimenta alucinaciones visuales amenazadoras",
        ]
    },
    {
        "n": 3,
        "pregunta": "3. Suicidio",
        "respuestas": [
            "0. Ausente",
            "1. Le parece que la vida no merece la pena ser vivida",
            "2. Desearía estar muerto o tiene pensamientos sobre la posibilidad de morirse",
            "3. Ideas de suicidio o amenazas",
            "4. Intentos de suicidio(cualquier intento serio se califica 4)",
        ]
    },
    {
        "n": 4, "pregunta": " 4. Insomnio precoz", "respuestas": [
            "0. Ausente",
            "1. Dificultades ocasionales para dormirse, por ejemplo, más de media hora",
            "2. Dificultades para dormirse cada noche",
        ]
    },
    {
        "n": 5, "pregunta": "5. Insomnio medio", "respuestas": [
            "0. Ausente",
            "1. El paciente se queja de estar inquieto durante la noche",
            "2. Está despierto durante la noche; cualquier ocasión de levantarse de la cama se califica 2(excepto si está justificada: orinar, tomar o dar medicación, etc.)",
        ]
    },
    {
        "n": 6,
        "pregunta": "6. Insomnio tardío ",
        "respuestas": [
            "0. Ausente",
            "1. Se despierta a primeras horas de la madrugada pero vuelve a dormirse",
            "2. No puede volver a dormirse si se levanta de la cama",
        ]
    },
    {
        "n": 7, "pregunta": "7. Trabajo y actividades", "respuestas": [
            "0. Ausente",
            "1. Ideas y sentimientos de incapacidad.Fatiga o debilidad relacionadas con su actividad, trabajo o aficiones",
            "2. Pérdida de interés en su actividad, aficiones, o trabajo, manifestado directamente por el enfermo o indirectamente por desatención, indecisión y vacilación",
            "3. Disminución del tiempo dedicado a actividades o descenso en la productividad",
            "4. Dejó de trabajar por la presente enfermedad",
        ]
    },
    {
        "n": 8, "pregunta": " 8. Inhibición(lentitud de pensamiento y de palabra, empeoramiento de la concentración, actividad motora disminuida)",
        "respuestas": [
            "0. Palabra y pensamiento normales",
            "1. Ligero retraso en el diálogo",
            "2. Evidente retraso en el diálogo",
            "3. Diálogo difícil",
            "4. Torpeza absoluta",
        ]
    },
    {
        "n": 9, "pregunta": " 9. Agitación", "respuestas": [
            "0. Ninguna",
            "1. “Juega” con sus manos, cabello, etc.",
            "2. Se retuerce las manos, se muerde las uñas, los labios, se tira de los cabellos, etc.",
        ]
    },
    {
        "n": 10, "pregunta": "10. Ansiedad psíquica", "respuestas": [
            "0. No hay dificultad",
            "1. Tensión subjetiva e irritabilidad",
            "2. Preocupación por pequeñas cosas",
            "3. Actitud aprensiva aparente en la expresión o en el habla",
            "4. Terrores expresados sin preguntarle",
        ]
    },
    {
        "n": 11, "pregunta": "11. Ansiedad somática", "respuestas": [
            "0. Ausente",
            "1. Ligera",
            "2. Moderada",
            "3. Grave",
            "4. Incapacitante\nSignos fisiológicos concomitantes de la ansiedad como: \n -Gastrointestinales: boca seca, flatulencia, diarrea, eructos, retortijones\n- Cardiovasculares: palpitaciones, cefalalgias\n- Respiratorios: hiperventilación, suspiros\n- Frecuencia urinaria\n- Sudoración"
        ]
    },
    {
        "n": 12, "pregunta": "12. Síntomas somáticos gastrointestinales",
        "respuestas": [
            "0. Ninguno",
            "1. Pérdida del apetito, pero come sin necesidad de que lo estimulen. Sensación de pesadez en el abdomen",
            "2. Dificultad en comer si no se le insiste.Solicita o necesita laxantes o medicación intestinal para sus síntomas gastrointestinales.",
        ]
    },
    {
        "n": 13, "pregunta": "13. Síntomas somáticos generales",
        "respuestas": [
            "0. Ninguno",
            "1. Pesadez en las extremidades, espalda o cabeza.Dorsalgias, cefalalgias, algias musculares.Pérdida de energía y fatigabilidad.",
            "2. Cualquier síntoma bien definido se califica 2",
        ]
    },
    {
        "n": 14, "pregunta": "14. Síntomas genitales ",
        "respuestas": [
            "0. Ausente",
            "1. Débil",
            "2. Grave",
            "3. Incapacitante\nSíntomas como\n- Pérdida de la libido\n- Trastornos menstruales",
        ]
    },
    {
        "n": 15, "pregunta": "15. Hipocondría",
        "respuestas": [
            "0. No la hay",
            "1. Preocupado de sí mismo(corporalmente)",
            "2. Preocupado por su salud",
            "3. Se lamenta constantemente, solicita ayudas, etc.",
            "4. Ideas delirantes hipocondríacas",
        ]
    },
    {
        "n": 16, "pregunta": "16. Pérdida de peso, según manifestaciones del paciente (primera evaluación)",
        respuestas: [
            "0. No hay pérdida de peso",
            "1. Probable pérdida de peso asociada con la enfermedad actual",
            "2. Pérdida de peso definida(según el enfermo)",
        ]
    },
    {
        "n": "B16", "pregunta": "16 B. Pérdida de peso, según pesaje hecho por el psiquiatra(evaluaciones siguientes)",
        "respuestas": [
            "0. Pérdida de peso inferior a 500 g en una semana",
            "1. Pérdida de peso de más de 500 g en una semana",
            "2. Pérdida de peso de más de 1 kg en una semana(por término medio)",
        ]
    },
    {
        "n": 17, "pregunta": "17. Insight(conciencia de enfermedad)",
        "respuestas": [
            "0. Se da cuenta de que está deprimido y enfermo",
            "1. Se da cuenta de su enfermedad pero atribuye la causa a la mala alimentación, clima, exceso de trabajo, virus, etc.",
            "2. Niega que esté enfermo",
        ]
    },

]

export const catalog2 = [
    {
        n: 1, pregunta: "1. Tristeza observada",
        descripcion: "Representa el abatimiento, la melancolía y la desesperación (algo más que una simple tristeza normal y pasajera) que se refleja en la manera de hablar, la expresión facial y la postura. Evalúe el grado de incapacidad para animarse.",
        respuestas: [
            "0. Sin tristeza",
            "1.",
            "2. Parece decaído/a pero se anima sin dificultad",
            "3.",
            "4. Parece triste y desgraciado/a la mayor parte del tiempo",
            "5.",
            "6. Parece siempre desgraciado/a. Extremadamente abatido/a",
        ]
    },
    {
        n: 2, pregunta: "2. Tristeza declarada por el paciente",
        descripcion: "Representa un estado de ánimo depresivoque se siente, sin tener en cuenta si se refleja en la apariencia o no.Incluye tristeza,abatimiento o el sentimiento de que no hayesperanza y nada ni nadie puede ayudarle.Evalúe de acuerdo con la intensidad, la duración y la medida en que el estado de ánimo se ve influido por los acontecimientos.",
        respuestas: [
            "0. Tristeza esporádica según las circunstancias",
            "1.",
            "2. Triste o decaído / a, pero se anima sin dificultad",
            "3.",
            "4. Sentimientos generalizados de tristeza o melancolía.El estado",
            "de ánimo todavía se ve influido por circunstancias externas",
            "5.",
            "6. Abatimiento, desdicha o tristeza continuada o invariable",
        ]
    },
    {
        n: 3, pregunta: "3. Tensión interna",
        descripcion: "Representa sentimientos de malestar mal definido, irritabilidad, confusión interna y tensión mental hasta llegar al pánico, terror o angustia.Evalúe de acuerdo con la intensidad, frecuencia, duración y la medida en que se busca consuelo.",
        respuestas: [
            "0. Apacible.Sólo tensión interna pasajera",
            "1.",
            "2. Sentimientos ocasionales de nerviosismo y malestar indefinido",
            "3.",
            "4. Sentimientos continuados de tensión interna o pánico intermitente que el sujeto sólo puede dominar con alguna dificultad",
            "5.",
            "6. Terror o angustia tenaz.Pánico irresistible",
        ]
    },
    {
        n: 4,
        pregunta: "4. Sueño reducido", descripcion: "Representa la reducción de la duración o profundidad del sueño comparada con las pautas normales del sujeto cuando se encuentra bien.",
        respuestas: [
            "0. Duerme como siempre",
            "1.",
            "2. Ligera dificultad para dormirse o sueño ligeramente reducido, sueño ligero o perturbado",
            "3.",
            "4. Sueño reducido o interrumpido durante al menos 2 h",
            "5.",
            "6. Menos de 2 o 3 h de sueño",
        ]
    },
    {
        n: 5,
        pregunta: "5. Apetito reducido", descripcion: "Representa la sensación de pérdida de apetito comparada con el que tiene cuando se encuentra bien.Evalúe según la pérdida del deseo por la comida o la necesidad de forzarse a sí mismo/a para comer.",
        respuestas: [
            "0. Apetito normal o aumentado",
            "1.",
            "2. Apetito ligeramente reducido",
            "3.",
            "4. Sin apetito.La comida es insípida",
            "5.",
            "6. Necesita persuasión para comer algo ",
        ]
    },
    {
        n: 6,
        pregunta: "6. Dificultades para concentrarse",
        descripcion: "Representa las dificultades para centrar los pensamientos en algo hasta llegar a la falta de concentración incapacitante.Evalúe según la intensidad, frecuencia y grado de incapacidad resultante.",
        respuestas: [
            "0. Ninguna dificultad para concentrarse",
            "1.",
            "2. Dificultades ocasionales para centrar los pensamientos",
            "3.",
            "4. Dificultades para concentrarse y seguir una idea que reduce la",
            "capacidad de leer o mantener una conversación",
            "5.",
            "6. Incapaz de leer o mantener una conversación si no es con gran dificultad",
        ]
    },
    {
        n: 7, pregunta: "7. Lasitud", descripcion: "Representa la dificultad para empezar algo o la lentitud para iniciar y realizar las actividades diarias.",
        respuestas: [
            "0. Casi sin dificultad para empezar algo.Sin apatía",
            "1.",
            "2. Dificultades para empezar actividades",
            "3.",
            "4. Dificultades para empezar actividades rutinarias sencillas que",
            "se llevan a cabo con esfuerzo",
            "5.",
            "6. Lasitud total.Incapaz de hacer nada sin ayuda",
        ]
    },
    {
        n: 8, pregunta: "8. Incapacidad para sentir", descripcion: "Representa la experiencia subjetiva de un menor interés por el entorno o por actividades que habitualmente dan placer.La capacidad para reaccionar con la emoción adecuada a las circunstancias o personas se ve reducida.",
        respuestas: [
            "0. Interés normal por el entorno y por otras personas",
            "1.",
            "2. Menor capacidad para disfrutar de las cosas que normalmente le interesan",
            "3.",
            "4. Pérdida de interés por el entorno.Pérdida de sentimientos",
            "respecto a los amigos y conocidos",
            "5.",
            "6. La experiencia de estar emocionalmente paralizado, incapacidad para sentir enfado, pena o placer y una total o incluso dolorosa falta de sentimientos hacia los parientes próximos y amigos",
        ]
    },
    {
        n: 9, pregunta: "9. Pensamientos pesimistas", descripcion: "Representa los pensamientos de culpabilidad, inferioridad, autorreproche, pecado, remordimiento y ruina.",
        respuestas: [
            "0. Sin pensamientos pesimistas",
            "1.",
            "2. Ideas variables de fracaso, autorreproche o autodesprecio",
            "3.",
            "4. Autoacusaciones persistentes o ideas definidas, pero aún",
            "racionales, de culpabilidad o pecado.Cada vez más pesimista",
            "respecto al futuro",
            "5.",
            "6. Alucinaciones de ruina, remordimiento o pecado irredimible. Autoacusaciones que son absurdas e inquebrantables",
        ]
    },
    {
        n: 10, pregunta: "10. Pensamientos suicidas", descripcion: "Representa el sentimiento de que no vale la pena vivir, que desearía que le llegara una muerte natural, pensamientos suicidas y preparativos para el suicidio.Los intentos de suicidio en sí no deberían influir en la evaluación.",
        respuestas: [
            "0. Disfruta de la vida o la acepta tal como viene",
            "1.",
            "2. Cansado de vivir.Sólo pensamientos suicidas pasajeros",
            "3.",
            "4. Probablemente estaría mejor muerto / a.Los pensamientos",
            "suicidas son habituales, y se considera el suicidio como una posible solución, pero sin ninguna intención o plan específico",
            "5.",
            "6. Planes explícitos de suicidio cuando se presente una oportunidad.Preparativos activos para el suicidio",
        ]
    }
]

export const catalog3 = [
    "Tener poco interés o disfrutar poco haciendo las cosas",
    "Sentirse desanimado/a, deprimido/a o sin esperanza",
    "Tener problemas para dormir o para mantenerse dormido, o dormir demasiado",
    "Sentirse cansado/a o tener poca energía",
    "Tener poco apetito o comer en exceso",
    "Sentirse mal consigo mismo/a-o sentirse fracasado/a, o pensar que se ha decepcionado a sí mismo o a los que le rodean",
    "Tener dificultades para concentrarse en cosas tales como leer el periódico o ver la televisión",
    "Moverse o hablar tan lentamente que los demás lo han notado. O bien al contrario, estar tan agitado/a o inquieto/a que se mueve mucho más de lo habitual",
    "Tener pensamientos sobre estar muerto/a o sobre hacerse daño a sí mismo de alguna manera",

]

export const preg10 = "Si usted se identificó con cualquier problema en este cuestionario, ¿le ha sido difícil cumplir con su trabajo, atender su casa, o relacionarse con otras personas debido a estos problemas?"